module.exports = __webpack_public_path__ + "Occupational-b0b99a6ea1691e5784ca6602994d4b4a.png";